export default "__VITE_ASSET__CkiCEdpN__"